import { api, tr } from './shared';

export function getYclientsSections(lang) {
  return [
    {
      id: 'yclients-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'YClients — обзор', 'YClients — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Интеграция YClients обслуживается через api.loyalclub.ru на уровне организации (не карты). Поддерживаются: webhook после визита, приложение Marketplace и iframe-plugin в окне записи. Типы карт: cashback, discount, stamp, subscription, certificate.',
            'YClients integration is served from api.loyalclub.ru at organization scope (not per card). Supported: visit webhooks, Marketplace app, and booking-window iframe plugin. Card types: cashback, discount, stamp, subscription, certificate.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Что нужно подготовить', 'What you need to prepare'),
          items: [
            tr(lang, 'Partner Token (обязателен) — из раздела API / Интеграции в YClients', 'Partner Token (required) — from the API / Integrations section in YClients'),
            tr(lang, 'Company ID (обязателен) — ID компании в YClients', 'Company ID (required) — company ID in YClients'),
            tr(lang, 'User Token (опционально) — если нужен доступ от имени пользователя', 'User Token (optional) — if user-scoped access is needed'),
            tr(lang, 'Совпадающий телефон клиента в YClients и Loyalclub', 'Matching client phone in YClients and Loyalclub'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Base URL', 'Base URL'),
          items: [`${api.host}/yclients`],
        },
        {
          type: 'list',
          title: tr(lang, 'Авторизация management API', 'Management API authorization'),
          items: ['Authorization: Bearer <USER_TOKEN>'],
        },
        {
          type: 'list',
          title: tr(lang, 'Авторизация в YClients API', 'YClients API authorization'),
          items: [
            'Authorization: Bearer <PARTNER_TOKEN>',
            'Authorization: Bearer <PARTNER_TOKEN>, User <USER_TOKEN>',
          ],
        },
      ],
    },
    {
      id: 'yclients-integration-create',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'Создать интеграцию', 'Create integration'),
      title: 'POST /yclients/integration/organization/{org_id}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Создаёт интеграцию на уровне организации и валидирует company_id в YClients. Возвращает webhook_url — его нужно прописать в настройках YClients.',
            'Creates an organization-level integration and validates company_id against YClients immediately. Returns webhook_url — add it to the YClients webhook settings.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Порядок подключения', 'Connection steps'),
          items: [
            tr(lang, '1. В YClients откройте API / Интеграции, скопируйте Partner Token и Company ID', '1. In YClients open API / Integrations, copy Partner Token and Company ID'),
            tr(lang, '2. При необходимости создайте User Token', '2. Create a User Token if needed'),
            tr(lang, '3. Вызовите POST /yclients/integration/organization/{org_id}', '3. Call POST /yclients/integration/organization/{org_id}'),
            tr(lang, '4. Скопируйте webhook_url из ответа', '4. Copy webhook_url from the response'),
            tr(lang, '5. В YClients добавьте webhook_url в разделе Webhooks для ресурса record', '5. In YClients add the webhook_url under Webhooks for the record resource'),
          ],
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'list',
          title: tr(lang, 'Поля запроса', 'Request fields'),
          items: [
            tr(lang, 'card_id (string, обязательно) — UUID карты лояльности', 'card_id (string, required) — loyalty card UUID'),
            tr(lang, 'bearer_token (string, обязательно) — Partner Token из YClients', 'bearer_token (string, required) — Partner Token from YClients'),
            tr(lang, 'company_id (string, обязательно) — ID компании в YClients', 'company_id (string, required) — YClients company ID'),
            tr(lang, 'user_token (string, опционально) — User Token из YClients', 'user_token (string, optional) — YClients User Token'),
            tr(lang, 'salon_name (string, опционально) — название салона', 'salon_name (string, optional) — salon name'),
            tr(lang, 'settings (object, опционально) — дополнительные настройки', 'settings (object, optional) — additional settings'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Коды ответов', 'Response codes'),
          items: [
            tr(lang, '200 — успешно, возвращает webhook_url', '200 — success, returns webhook_url'),
            tr(lang, '400 — невалидные credentials (проверка в YClients не прошла)', '400 — invalid credentials (YClients validation failed)'),
            tr(lang, '401 — не авторизован', '401 — unauthorized'),
            tr(lang, '403 — нет доступа', '403 — forbidden'),
            tr(lang, '409 — интеграция для карты уже существует', '409 — integration for this card already exists'),
          ],
        },
        {
          type: 'code',
          title: tr(lang, 'Тело запроса', 'Request body'),
          key: 'yclients-int-create-body',
          value: `{\n  "card_id": "<CARD_UUID>",\n  "bearer_token": "<PARTNER_TOKEN>",\n  "company_id": "123456",\n  "user_token": "<USER_TOKEN>",\n  "settings": {}\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'yclients-int-create',
          value: `curl -X POST "${api.host}/yclients/integration/organization/<ORG_UUID>" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{\n    "card_id": "<CARD_UUID>",\n    "bearer_token": "<PARTNER_TOKEN>",\n    "company_id": "123456"\n  }'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа (успех)', 'Example response (success)'),
          key: 'yclients-int-create-resp',
          value: `{\n  "id": 5,\n  "organization_id": 42,\n  "card_id": 7,\n  "company_id": "123456",\n  "salon_name": "Студия Nail Art",\n  "webhook_url": "${api.host}/yclients/webhook/abc123secret",\n  "is_active": true\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 400 — невалидные credentials', '400 error — invalid credentials'),
          key: 'yclients-int-create-err-400',
          value: `HTTP/1.1 400 Bad Request\n\n{\n  "detail": "YClients credentials validation failed: invalid partner token or company_id"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 409 — интеграция уже существует', '409 error — integration already exists'),
          key: 'yclients-int-create-err-409',
          value: `HTTP/1.1 409 Conflict\n\n{\n  "detail": "Integration for this card already exists"\n}`,
        },
      ],
    },
    {
      id: 'yclients-verify',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 15,
      navLabel: tr(lang, 'Проверить токены', 'Verify credentials'),
      title: 'POST /yclients/verify-credentials',
      blocks: [
        { type: 'text', value: tr(lang, 'Проверяет bearer_token и company_id без создания интеграции. Используйте перед сохранением настроек.', 'Validates bearer_token and company_id without creating an integration. Use before saving settings.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — проверка пройдена или нет (см. поле success)', '200 — check passed or failed (see success field)'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: 'curl',
          key: 'yclients-verify',
          value: `curl -X POST "${api.host}/yclients/verify-credentials" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{"bearer_token": "<PARTNER_TOKEN>", "company_id": "123456"}'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа (успех)', 'Example response (success)'),
          key: 'yclients-verify-resp',
          value: `{\n  "success": true,\n  "salon_name": "Студия Nail Art",\n  "company_id": "123456"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа (невалидные credentials)', 'Example response (invalid credentials)'),
          key: 'yclients-verify-resp-fail',
          value: `HTTP/1.1 200 OK\n\n{\n  "success": false,\n  "error": "Unauthorized: invalid partner token or company_id"\n}`,
        },
      ],
    },
    {
      id: 'yclients-integration-by-card',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: tr(lang, 'Получить интеграцию', 'Get integration'),
      title: 'GET /yclients/integration/organization/{org_id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает текущую конфигурацию и webhook URL.', 'Returns current configuration and the webhook URL.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        {
          type: 'code',
          title: 'curl',
          key: 'yclients-int-get',
          value: `curl -X GET "${api.host}/yclients/integration/organization/<ORG_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'yclients-integration-update',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 30,
      navLabel: tr(lang, 'Обновить интеграцию', 'Update integration'),
      title: 'PUT /yclients/integration/organization/{org_id}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Обновляет настройки. При изменении bearer_token или company_id автоматически перепроверяет их в YClients.',
            'Updates settings. Changing bearer_token or company_id automatically re-validates them against YClients.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '400 — невалидные credentials', '400 — invalid credentials'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'yclients-int-update',
          value: `curl -X PUT "${api.host}/yclients/integration/organization/<ORG_UUID>" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{"is_active": true, "company_id": "123456", "salon_name": "Studio Nail Art"}'`,
        },
      ],
    },
    {
      id: 'yclients-integration-delete',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 40,
      navLabel: tr(lang, 'Удалить интеграцию', 'Delete integration'),
      title: 'DELETE /yclients/integration/organization/{org_id}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Удаляет интеграцию. Если для интеграции уже существуют транзакции — вернёт HTTP 409. В этом случае используйте деактивацию (is_active: false).',
            'Deletes the integration. If transactions already exist for the integration — returns HTTP 409. In this case use deactivation (is_active: false).',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — удалено', '200 — deleted'), tr(lang, '404 — не найдено', '404 — not found'), tr(lang, '409 — есть связанные транзакции', '409 — has linked transactions')] },
        {
          type: 'code',
          title: 'curl',
          key: 'yclients-int-delete',
          value: `curl -X DELETE "${api.host}/yclients/integration/organization/<ORG_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'yclients-health',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 50,
      navLabel: tr(lang, 'Матрица поддержки', 'Support matrix'),
      title: 'GET /yclients/integration/organization/{org_id}/health',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает webhook URL, apply-статус и матрицу поддерживаемых flows по типам карт.', 'Returns the webhook URL, apply status and the flow support matrix by card type.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'code',
          title: 'curl',
          key: 'yclients-health',
          value: `curl -X GET "${api.host}/yclients/integration/organization/<ORG_UUID>/health" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
        {
          type: 'code',
          title: tr(lang, 'Пример ответа', 'Example response'),
          key: 'yclients-health-resp',
          value: `{\n  "integration_id": 5,\n  "is_active": true,\n  "company_id": "123456",\n  "salon_name": "Студия Nail Art",\n  "webhook_url": "${api.host}/yclients/webhook/abc123...",\n  "apply_status": "completed",\n  "flow_support": {\n    "cashback": { "apply": true, "reverse": true },\n    "discount": { "apply": true, "reverse": true },\n    "stamp":    { "apply": true, "reverse": true },\n    "subscription": { "apply": true, "reverse": true },\n    "certificate":  { "apply": true, "reverse": true }\n  }\n}`,
        },
      ],
    },
    {
      id: 'yclients-webhook-setup',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Webhook', 'Webhook'),
      navSubgroupOrder: 20,
      navOrder: 5,
      navLabel: tr(lang, 'Настройка webhook', 'Webhook setup'),
      title: tr(lang, 'YClients — настройка webhook', 'YClients — webhook setup'),
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Как настроить webhook в YClients', 'How to configure the webhook in YClients'),
          items: [
            tr(lang, '1. Создайте интеграцию и получите webhook_url', '1. Create the integration and get the webhook_url'),
            tr(lang, '2. В YClients перейдите в API / Webhooks', '2. In YClients go to API / Webhooks'),
            tr(lang, '3. Добавьте webhook_url как URL обработчика', '3. Add the webhook_url as the handler URL'),
            tr(lang, '4. Выберите ресурс: record', '4. Select resource: record'),
            tr(lang, '5. Включите события: изменение статуса записи (completed, cancel и их вариации)', '5. Enable events: record status change (completed, cancel and their variations)'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Статусы, которые начисляют (apply)', 'Statuses that apply (accrue)'),
          items: ['completed'],
        },
        {
          type: 'list',
          title: tr(lang, 'Статусы, которые отменяют (reverse)', 'Statuses that reverse (cancel)'),
          items: [
            'cancel, canceled, cancelled',
            'cancelled_by_client, cancelled_by_staff',
            'deleted, no_show, not_come, did_not_come',
            'not_confirmed, refunded',
            tr(lang, 'Любой статус начинающийся на cancel или заканчивающийся на cancelled/canceled', 'Any status starting with cancel or ending with cancelled/canceled'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Важно', 'Important'),
          items: [
            tr(lang, 'Телефон клиента в YClients должен совпадать с телефоном в Loyalclub', 'Customer phone in YClients must match the phone in Loyalclub'),
            tr(lang, 'Повторные вызовы с тем же resource_id безопасны — идемпотентность гарантируется', 'Repeated calls with the same resource_id are safe — idempotency is guaranteed'),
          ],
        },
      ],
    },
    {
      id: 'yclients-webhook',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Webhook', 'Webhook'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: tr(lang, 'Webhook визитов', 'Visits webhook'),
      title: 'POST /yclients/webhook/{webhook_secret}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Принимает события от YClients по записи. Статус completed применяет операцию лояльности, статусы отмены выполняют обратную операцию. Авторизация не требуется — доступ ограничен секретом в URL.',
            'Accepts record events from YClients. The completed status applies the loyalty operation, cancel statuses reverse it. No authorization needed — access is limited by the secret in the URL.',
          ),
        },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['webhook_secret (string) — из поля webhook_url интеграции'] },
        {
          type: 'list',
          title: tr(lang, 'Операции по типу карты', 'Operations by card type'),
          items: [
            tr(lang, 'cashback — начисляется total_amount × cashback_percent / 100', 'cashback — accrues total_amount × cashback_percent / 100'),
            tr(lang, 'discount — total_spent += total_amount, обновляет тир скидки', 'discount — total_spent += total_amount, updates discount tier'),
            tr(lang, 'stamp — +1 штамп; при достижении порога — +1 награда', 'stamp — +1 stamp; on reaching threshold — +1 reward'),
            tr(lang, 'subscription — +1 визит, проверяется лимит subscriptionVisitsCount', 'subscription — +1 visit, checks subscriptionVisitsCount limit'),
            tr(lang, 'certificate — списывается total_amount с баланса сертификата', 'certificate — total_amount is deducted from the certificate balance'),
          ],
        },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — обработано (или дубликат)', '200 — processed (or duplicate)'), tr(lang, '404 — интеграция не найдена', '404 — integration not found')] },
        {
          type: 'code',
          title: tr(lang, 'Пример тела от YClients', 'Example body from YClients'),
          key: 'yclients-webhook-body',
          value: `{\n  "company_id": 123456,\n  "resource": "record",\n  "resource_id": 987654,\n  "status": "completed",\n  "data": {\n    "total_amount": 2500,\n    "client": {\n      "phone": "+79990001122"\n    }\n  }\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'yclients-webhook',
          value: `curl -X POST "${api.host}/yclients/webhook/<WEBHOOK_SECRET>" \\\n  -H "Content-Type: application/json" \\\n  -d '{\n    "company_id": 123456,\n    "resource": "record",\n    "resource_id": 987654,\n    "status": "completed",\n    "data": {\n      "total_amount": 2500,\n      "client": { "phone": "+79990001122" }\n    }\n  }'`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ошибка 404 — интеграция не найдена', '404 error — integration not found'),
          key: 'yclients-webhook-err-404',
          value: `HTTP/1.1 404 Not Found\n\n{\n  "detail": "Integration not found for webhook secret"\n}`,
        },
        {
          type: 'code',
          title: tr(lang, 'Ответ 200 — клиент не найден (без транзакции)', '200 response — client not found (no transaction)'),
          key: 'yclients-webhook-err-no-client',
          value: `HTTP/1.1 200 OK\n\n{\n  "status": "skipped",\n  "reason": "Client with phone +79990001122 not found in Loyalclub"\n}`,
        },
      ],
    },
    {
      id: 'yclients-marketplace-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Marketplace', 'Marketplace'),
      navSubgroupOrder: 30,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор Marketplace', 'Marketplace overview'),
      title: tr(lang, 'YClients Marketplace — обзор', 'YClients Marketplace — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Приложение в маркетплейсе YClients бесплатное. Подписка оплачивается в Loyalclub. Установка филиала идёт через Registration Redirect URL, события uninstall/freeze — через Callback URL.',
            'The YClients Marketplace app is free. Subscription is billed in Loyalclub. Branch install goes through Registration Redirect URL; uninstall/freeze events go through Callback URL.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'URL для регистрации приложения', 'URLs for app registration'),
          items: [
            `Registration Redirect: ${api.host}/yclients/marketplace/install`,
            `Callback: ${api.host}/yclients/marketplace/callback?token=<YCLIENTS_CALLBACK_TOKEN>`,
            `Plugin iframe (клиент): ${api.host}/yclients/plugin/frame/client`,
            `Plugin iframe (визит): ${api.host}/yclients/plugin/frame/visit`,
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Что включить в форме YClients', 'What to enable in the YClients form'),
          items: [
            tr(lang, 'Раздел о клиенте в окне записи', 'Client section in the booking window'),
            tr(lang, 'Раздел о визите в окне записи', 'Visit section in the booking window'),
          ],
        },
      ],
    },
    {
      id: 'yclients-marketplace-install',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Marketplace', 'Marketplace'),
      navSubgroupOrder: 30,
      navOrder: 10,
      navLabel: 'GET /marketplace/install',
      title: 'GET /yclients/marketplace/install',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Registration Redirect URL. YClients открывает страницу установки; после привязки организации интеграция активируется в филиале.',
            'Registration Redirect URL. YClients opens the install page; after organization binding the integration is activated for the branch.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Типичный flow', 'Typical flow'),
          items: [
            tr(lang, '1. Салон устанавливает приложение в Marketplace', '1. Salon installs the app in Marketplace'),
            tr(lang, '2. Открывается /yclients/marketplace/install с подписанными user_data', '2. /yclients/marketplace/install opens with signed user_data'),
            tr(lang, '3. Пользователь привязывает организацию Loyalclub / создаёт интеграцию', '3. User binds Loyalclub organization / creates integration'),
            tr(lang, '4. POST /yclients/integration/organization/{org_id} с company_id и marketplace_salon_id', '4. POST /yclients/integration/organization/{org_id} with company_id and marketplace_salon_id'),
          ],
        },
      ],
    },
    {
      id: 'yclients-marketplace-callback',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Marketplace', 'Marketplace'),
      navSubgroupOrder: 30,
      navOrder: 20,
      navLabel: 'GET|POST /marketplace/callback',
      title: 'GET|POST /yclients/marketplace/callback',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Входящий Callback URL. Обрабатывает uninstall и freeze: отзывает plugin sessions и помечает установку как disabled/frozen. Требует token в query или заголовок X-YClients-Callback-Token.',
            'Inbound Callback URL. Handles uninstall and freeze: revokes plugin sessions and marks the install as disabled/frozen. Requires token in query or X-YClients-Callback-Token header.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Авторизация', 'Authorization'),
          items: [
            '?token=<YCLIENTS_CALLBACK_TOKEN>',
            'X-YClients-Callback-Token: <YCLIENTS_CALLBACK_TOKEN>',
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'События', 'Events'),
          items: ['uninstall', 'freeze', tr(lang, 'прочие события логируются / игнорируются безопасно', 'other events are logged / safely ignored')],
        },
      ],
    },
    {
      id: 'yclients-plugin-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Plugin iframe', 'Plugin iframe'),
      navSubgroupOrder: 40,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор plugin', 'Plugin overview'),
      title: tr(lang, 'YClients Plugin — iframe в окне записи', 'YClients Plugin — booking-window iframe'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Plugin встраивается во вкладки клиента и визита. Сессия создаётся через /plugin/session, UI загружает bootstrap и выполняет card-action (начисление/списание) без выхода из YClients.',
            'The plugin embeds into client and visit tabs. Session is created via /plugin/session, UI loads bootstrap and runs card-action (accrue/redeem) without leaving YClients.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Ключевые эндпоинты', 'Key endpoints'),
          items: [
            `GET ${api.host}/yclients/plugin/frame/client`,
            `GET ${api.host}/yclients/plugin/frame/visit`,
            `POST ${api.host}/yclients/plugin/session`,
            `GET ${api.host}/yclients/plugin/bootstrap`,
            `POST ${api.host}/yclients/plugin/card-action`,
            `POST ${api.host}/yclients/plugin/client/resolve`,
            `POST ${api.host}/yclients/plugin/client-cards/issue`,
          ],
        },
      ],
    },
    {
      id: 'yclients-plugin-session',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Plugin iframe', 'Plugin iframe'),
      navSubgroupOrder: 40,
      navOrder: 10,
      navLabel: 'POST /plugin/session',
      title: 'POST /yclients/plugin/session',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Создаёт plugin-сессию для iframe. Также доступен вариант POST /yclients/plugin/session/{plugin_secret}.',
            'Creates a plugin session for the iframe. Also available as POST /yclients/plugin/session/{plugin_secret}.',
          ),
        },
        {
          type: 'code',
          title: 'curl',
          key: 'yc-plugin-session',
          value: `curl -X POST "${api.host}/yclients/plugin/session" \\\n  -H "Content-Type: application/json" \\\n  -d '{"salon_id":"123456","entity_type":"client"}'`,
        },
      ],
    },
    {
      id: 'yclients-plugin-card-action',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'YClients',
      navGroupOrder: 30,
      navSubgroup: tr(lang, 'Plugin iframe', 'Plugin iframe'),
      navSubgroupOrder: 40,
      navOrder: 20,
      navLabel: 'POST /plugin/card-action',
      title: 'POST /yclients/plugin/card-action',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Операция лояльности из iframe (начисление/списание/штамп и т.д.) в контексте активной plugin-сессии.',
            'Loyalty operation from the iframe (accrue/redeem/stamp, etc.) in the context of an active plugin session.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Связанные методы', 'Related methods'),
          items: [
            'GET /yclients/plugin/bootstrap',
            'POST /yclients/plugin/client/resolve',
            'POST /yclients/plugin/client/create',
            'POST /yclients/plugin/client/link',
            'GET /yclients/plugin/cards',
            'POST /yclients/plugin/client-cards/issue',
            'GET /yclients/plugin/client/{client_uuid}/transactions',
          ],
        },
      ],
    },
  ];
}